//====================================================
//  Function: Change Content
//====================================================
function componentChangeContent() {
  if ($("#footer").length == 1) {
    // FOOTER
    if ($("#footer").length) {
      // signature
      $("#footer .footer-bottom #signature").html(
        "<span class='author'>Vyrobilo <strong>beioe.com</strong> <a href='https://beioe.com/' target='_blank'> <img src='/user/documents/public/images/icons/beioe.svg'>  </a></span>"
      );

      // Copyright
      $("#footer .footer-bottom .copyright").html(
        copy + " <strong>TatraTree." + lang + "</strong> 2020"
      );
    }

    // HEADER
    if ($(".top-navigation-bar-menu").length) {
      $('.top-navigation-bar-menu a[title="Kontakty"]').text("Kontaktujte nás");
    }

    if ($("#header .header-top").length) {
      var contactHeader = $(".zapati .contact").clone();
      $("#header .header-top .site-name").append(contactHeader);

      $("#header .query-input").attr("placeholder", search);

      var searchSvg =
        '<svg class="icon-svg icon-search"><use xlink:href="https://www.365121.myshoptet.' +
        lang +
        '/user/documents/public/images/sprites.svg#icon-search"></use></svg>';
      $(".search-form .btn-default").html(searchSvg);

      $("#header #navigation").append('<div class="navigation-bottom"></div>');

      // if ($(window).width() < 768) {
      //   $(".header-top .search").insertBefore(
      //     $("#navigation .navigation-in .menu-level-1")
      //   );
      // }

      var contactHeader = $(".zapati .contact").clone();
      $("#header #navigation .navigation-bottom").append(contactHeader);
    }

    if ($(".top-navigation-bar .top-navigation-menu").length) {
      var socialHeader = $(".zapati .social").clone();
      $(".top-navigation-bar .container .top-navigation-menu").prepend(
        socialHeader
      );

      var socialHeader = $(".zapati .social").clone();
      $("#header #navigation .navigation-bottom").append(socialHeader);
    }

    if ($(".top-nav-button").length) {
      // var favorite = "<a href='oblibene'>"

      var login = $(".top-nav-button");
      var loginSvg =
        '<svg class="icon-svg icon-user"><use xlink:href="https://www.365121.myshoptet.' +
        lang +
        '/user/documents/public/images/sprites.svg#icon-user"></use></svg>';
      $(".navigation-buttons").prepend(login);

      login.append(loginSvg);

      if ($(".top-nav-button-login").length) {
        $(".top-nav-button-login").click(function () {
          window.location.href = registrationLink;
          return false;
        });
      }

      if ($(".top-nav-button-login").length) {
        $(".top-nav-button-login").wrapAll('<div class="click-login"></div>');
        $(".click-login").click(function () {
          window.location.href = registrationLink;
          return false;
        });
      }

      if ($(".top-nav-button-account").length) {
      }
    }

    if ($(".top-navigation-tools .responsive-tools").length) {
      $("#header .navigation-buttons").append(
        $(".top-navigation-tools .responsive-tools")
      );

      var menuSvg =
        '<svg class="icon-svg icon-menu"><use xlink:href="https://www.365121.myshoptet.' +
        lang +
        '/user/documents/public/images/sprites.svg#icon-menu"></use></svg><svg class="icon-svg icon-close"><use xlink:href="https://www.365121.myshoptet.' +
        lang +
        '/user/documents/public/images/sprites.svg#icon-close"></use></svg>';
      $(
        ".navigation-buttons .responsive-tools .toggle-window[data-target='navigation'"
      ).append(menuSvg);
    }
  }
}
